import css from './authPage.module.css'
import FormField from '../../shared/Forms/FormField'
import TextInput from '../../shared/Inputs/TextInput'
import Checkbox from '../../shared/Inputs/Checkbox'
import Button from '../../shared/Buttons/Button'
import logoIcon from '../../assets/images/logo.png'
import logoBg from '../../assets/images/authBg.webp'
import logoLetter from '../../assets/images/logoLetter.png'
import useAuthScreen from './useAuthScreen.ts'
import Form from '../../shared/Forms/Form'
import useTitle from '@/shared/hooks/useTitle'

const Auth = () => {
  useTitle('Авторизация')
  const ctrl = useAuthScreen()

  return (
    <div className={css.wrapper}>
      <div className="inline-flex-gap width100 height100 center gap24">
        <div className={css.contentWrapper}>
          <div className={css.header}>
            <img alt="Интерхтех" src={logoIcon} className={css.logo} />
          </div>
          <Form onSubmit={ctrl.handleSubmit} className={css.content}>
            <h3 className="text-heading-3 mb16">Авторизация</h3>
            <div className="flex-lines gap12">
              <FormField label="Логин">
                <TextInput
                  value={ctrl.state.login}
                  name="login"
                  onChange={ctrl.handleChange}
                  placeHolder="Логин"
                  error={Boolean(ctrl.error)}
                  size="large"
                />
              </FormField>
              <FormField label="Пароль">
                <TextInput
                  value={ctrl.state.password}
                  name="password"
                  onChange={ctrl.handleChange}
                  placeHolder="••••••••"
                  type="password"
                  error={Boolean(ctrl.error)}
                  inscription={ctrl.error}
                  size="large"
                />
              </FormField>
              <Checkbox
                label="Запомнить меня"
                checked={ctrl.state.rememberMe}
                onCheck={ctrl.handleChange}
                name="rememberMe"
              />
            </div>
            <div className="mt16">
              <Button
                size="large"
                type="primary"
                text="Войти"
                loading={ctrl.loading}
                fullWidth={true}
                buttonType="submit"
                disabled={!ctrl.state.login || !ctrl.state.password}
              />
            </div>
          </Form>
          <div className={css.footer}>
            <p className="text-nm text-secondary text-center text-pre">
              ООО «Интертех»{'\n'}
              {new Date().getFullYear()} © Все права защищены
            </p>
          </div>
        </div>
        <div className="flex-lines width100 height100" style={{ position: 'relative' }}>
          <img alt="bg" src={logoBg} className={css.image} />
          <img alt="И" src={logoLetter} className={css.letter} />
        </div>
      </div>
    </div>
  )
}

export default Auth
